<script>
    import app from '../../stores/app';

    export let userId = 0;
</script>

<select class="form-select" bind:value={userId}>
    <option value=0>Δημόσιος</option>
    {#each $app.users as item}
        <option value={item.id}>{item.name}</option>
    {/each}
</select>